import { css, keyframes } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button';
import { xcss } from '@atlaskit/primitives';
import { Cell as TableCell } from '@atlaskit/table-tree';
import { themed } from '@atlaskit/theme/components';
import { token } from '@atlaskit/tokens';

export const Wrapper = styled.div({});

export const MessageWrapper = styled.div({
  margin: `0 0 ${token('space.200')}`,
});

export const NoBrancheSelectorMessage = styled.div({
  margin: `0 0 ${token('space.200')}`,
});

export const FooterButtons = styled.div({
  margin: `${token('space.200')} 0`,
  display: 'flex',
  justifyContent: 'flex-end',
});

export const SelectorWrapper = styled.div({
  width: '400px',
  display: 'inline-block',
  marginRight: token('space.100'),
  marginBottom: token('space.200'),
});

export const CustomSelectorWrapper = styled.div({
  width: '400px',
  marginRight: token('space.100'),
  marginBottom: token('space.200'),
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression
export const Label = styled.label`
  font: ${token('font.body.UNSAFE_small')};
  color: ${themed({
    light: token('color.text.subtlest'),
    dark: token('color.text.subtlest'),
  })};
  font-weight: ${token('font.weight.semibold')};
  display: inline-block;
  margin-bottom: ${token('space.050')};
  margin-top: 0;
  width: 100%;
`;

export const VariablesWrapper = styled.div({
  marginTop: token('space.200'),
  table: {
    borderTop: `2px solid ${token('color.border')}`,
  },
  'tr:hover': {
    background: token('elevation.surface.hovered'),
  },
});

export const VariablesKeyColumn = styled.td({
  maxWidth: '200px',
});

export const VariableDescriptionWrapper = styled.span({
  color: token('color.text.subtle'),
  display: 'inline-flex',
  width: 0,
  minWidth: '100%',
});

export const VariablesDescription = styled.span({
  font: token('font.body.UNSAFE_small'),
  display: 'inline-block',
  verticalAlign: 'middle',
  paddingBottom: token('space.050'),
  overflowWrap: 'anywhere',
});

export const VariableKey = styled.div({
  padding: '0 10px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const Header = styled.span({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const Information = styled.div({
  flex: '1 0 auto',
  marginLeft: token('space.050'),
  height: '22px',
});

export const ScheduleGroup = styled.div({
  display: 'flex',
  alignItems: 'flex-end',
  flexWrap: 'wrap',
  marginBottom: token('space.200'),
  '& > div:last-of-type': {
    width: '144px',
    margin: 0,
  },
  '& > *, & > *:first-of-type': {
    width: '120px',
    marginRight: token('space.100'),
  },
  '& > p': {
    font: token('font.body.small'),
    color: token('color.text.subtlest'),
    flexBasis: '100%',
    margin: `${token('space.100')} 0`,
  },
});

export const SchedulesDialogWrapper = styled.div({
  width: '448px',
});

export const SchedulesWrapper = styled.div({
  textAlign: 'left',
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: token('space.150'),
  },
});

export const SchedulesTitle = styled.h3({
  font: token('font.heading.medium'),
  color: 'inherit',
  flex: '1 0 auto',
});

export const SchedulesListOld = styled.div({
  maxHeight: '200px',
  overflow: 'scroll',
});

export const containerStyles = xcss({
  font: 'font.body.UNSAFE_small',
  overflow: 'scroll',
});
export const columnHeaderStyles = xcss({
  color: 'color.text.subtlest',
  paddingBottom: 'space.0',
  borderBottom: `2px solid ${token('color.border')}`,
});

export const SchedulesRows = styled.div`
  max-height: 200px;
  overflow: scroll;
  div[role='row'] {
    border: none;
    text-align: left;
    height: 41px;
    div[role='gridcell'] {
      flex-shrink: 0;
      overflow: hidden;
      padding-right: ${token('space.100')};
      span {
        flex-shrink: 0;
      }
      &:nth-of-type(3) span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
      }
      &:nth-of-type(4) {
        span {
          max-width: 100%;
        }
        span > div > div:last-child {
          max-width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    &:hover {
      background: ${token('elevation.surface.hovered')};
      button {
        display: inline-flex;
      }
    }
  }
`;

export const SchedulesTable = styled.table({
  tbody: {
    borderBottomWidth: 0,
  },
  th: {
    color: token('color.text.subtlest'),
    font: token('font.body.UNSAFE_small'),
    fontWeight: token('font.weight.medium'),
  },
  'td:last-child, th:last-child': {
    paddingLeft: 0,
  },
});

const highlightAnimation = keyframes({
  '0%': {
    background: token('color.background.input'),
  },
  '100%': {
    background: 'none',
  },
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression
export const SchedulesRow = styled.tr<{ isNew: boolean; isEnabled: boolean }>`
  animation: ${props =>
    !props.isNew
      ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
        css`
          ${highlightAnimation} 1.5s ease-in
        `
      : 'none'};
  ${props =>
    !props.isEnabled ? `color: ${token('color.text.subtlest')}` : ''};

  td {
    height: 32px;
    font: ${token('font.body.UNSAFE_small')};

    &:nth-child(1) {
      width: 44px;
    }

    &:nth-child(2) div {
      width: 80px;
    }

    &:nth-child(3) div {
      width: 90px;
    }

    &:nth-child(4) > div {
      width: 138px;
    }

    &:nth-child(5) {
      width: 40px;
    }

    &:nth-child(2) div,
    &:nth-child(3) div,
    &:nth-child(4) div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &:hover {
    background: ${token('color.background.neutral.hovered')};
    button {
      visibility: visible;
    }
  }
`;
export const OpenDeleteScheduleDialogButton = styled(Button)({
  visibility: 'hidden',
});
export const DeleteBtnCell = styled(TableCell)`
  padding-left: 8px !important;
  &:hover ${OpenDeleteScheduleDialogButton} {
    visibility: visible;
    background: ${token('color.background.neutral.hovered')};
  }
`;
export const VariableCell = styled(TableCell)({
  'span, div': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
});
export const VariableDefaultCell = styled(TableCell)({
  span: {
    overflow: 'visible',
    color: token('color.text.subtlest'),
    fontWeight: token('font.weight.medium'),
  },
});

export const EmptySchedules = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});
export const SchedulesHeadRow = styled.tr({
  th: {
    '&:nth-child(1)': {
      width: '44px',
    },
    '&:nth-child(2)': {
      width: '80px',
    },
    '&:nth-child(3)': {
      width: '90px',
    },
    '&:nth-child(4)': {
      width: '138px',
    },
  },
});

export const SchedulesDateWrapper = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

export const SchedulesWarning = styled.div({
  color: token('color.text.danger'),
});

export const SchedulesEmpty = styled.td({
  textAlign: 'center',
  svg: {
    marginTop: token('space.100'),
    position: 'relative',
  },
});

export const CreateScheduleButtonWrapper = styled.div({
  position: 'relative',
});

export const CreateScheduleButtonOverlay = styled.div({
  zIndex: 1,
  width: '100%',
  height: '100%',
  position: 'absolute',
  cursor: 'not-allowed',
});
